import React, { useState, useEffect } from 'react';
import RecommendCityList from '../RecommendCityList'

const RecommendedCities = () => {

    const [topCities, setTopCities] = useState();

    useEffect(() => {
        fetchOurTopCities();
    }, []);

    const fetchOurTopCities = () => {
        fetch('./data/recommended_cities.json')
            .then(res => res.json())
            .then(res => setTopCities(res))
            .catch(function(error) {
                console.log("Hit an error!");
                console.log(error);
            });
    };

    return (
        <div>
            {
                topCities && (
                    topCities.map((contient) => {
                        return (
                            <RecommendCityList {...contient} key={contient.name} />
                        );
                    })
                )
            }
        </div>
    );
    
};

export default RecommendedCities;